import React from "react";
import { Text, TEXT_COLORS, TEXT_TYPES } from "#library/components/Text/Text";
import styles from "./fieldContainer.module.css";
var FieldSwitchText = function FieldSwitchText(_ref) {
  var hasError = _ref.hasError,
    errorText = _ref.errorText,
    helpText = _ref.helpText,
    className = _ref.className;
  var shouldRender = hasError || !!helpText && helpText.length > 0;
  var shouldRenderError = hasError && errorText && errorText.length > 0;
  var shouldRenderHelpText = !hasError && helpText && helpText.length > 0;
  return shouldRender ? /*#__PURE__*/React.createElement("div", {
    className: styles["jds-FieldContainer__switchText"]
  }, shouldRenderError && /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    color: TEXT_COLORS.ERROR,
    type: TEXT_TYPES.MINOR,
    className: className
  }, errorText) || shouldRenderHelpText && /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    color: TEXT_COLORS.GREY,
    type: TEXT_TYPES.MINOR,
    className: className
  }, helpText)) : null;
};
/*
 * errorText will show only if hasError is set to true.
 * This allows to prefill errorText with basic error message.
 */

export { FieldSwitchText };